import React from 'react';
function Spin(){
    return (
        <div className="u-load s-fc3">
            <i className="icn"></i> 加载中...
        </div>
    )
}
export default Spin;


// WEBPACK FOOTER //
// ./client/component/spin.js